import React from "react";
import { Container } from "react-bootstrap";
import "./instructions.css";

const Instructions = () => {
  return (
    <Container className="instructions">
      <h1 className="text-center my-5">Instruction for Installation</h1>
      <p>
        Prior to the installation of PDF-Toolkit, you must install ghostscript
        64bit in your PC, there is two ways in which it can be installed.
      </p>
      <h2>Method 1</h2>
      <ul>
        <li>
          Click{" "}
          <a download="gs.rar" href="/assets/files/gs.rar">
            here
          </a>{" "}
          to download the ghostscript,{" "}
        </li>
        <li>Copy the ‘gs” folder and paste it in the root of your “C” drive</li>
      </ul>
      <img
        alt="gs-file-location"
        className="mb-5"
        src="/assets/images/cdrive.png"
      />
      <h2>Method 2</h2>
      <ul>
        <li>
          Download ghostscript 64 bit from the official website{" "}
          <a href="https://ghostscript.com/releases/gsdnld.html">
            “https://ghostscript.com/releases/gsdnld.html”
          </a>
        </li>
        <li>Install the ghostscript on your PC.</li>
        <li>
          Go to the installation folder of the ghostscript in your “C” drive and
          copy the “gs” folder and paste it in your root of your “C” drive
        </li>
      </ul>
      <p>
        After installing the ghostscript, the PDF-Toolkit can be used by opening
        the “PDF-Toolkit.exe” file. No installation is needed in order to use
        the software.
      </p>
    </Container>
  );
};

export default Instructions;
